import { useId } from 'react'

/**
 * 朱の印。白抜きの字を縦に並べ、押したときのかすれと滲みをフィルタで出す。
 * 字は飾りなので支援技術には読ませない（店名などは隣の文字で伝える）
 */
export function Hanko({
  text = '集中',
  size = 34,
  shape = 'square',
  className = '',
}: {
  text?: string
  size?: number
  shape?: 'square' | 'round'
  className?: string
}) {
  const id = useId().replace(/:/g, '')
  const chars = Array.from(text)
  // 1字なら大きく中央に、2〜3字なら縦一列に、4字なら右の列から縦に読む2列に組む
  const grid = chars.length === 4
  const fs = grid ? 15.5 : chars.length === 1 ? 26 : chars.length === 2 ? 16.5 : 11.5
  const gap = fs * 1.02
  const top = grid ? 20 - gap / 2 : 20 - ((chars.length - 1) * gap) / 2
  const pos = (i: number) =>
    grid ? { x: i < 2 ? 28.5 : 11.5, y: top + (i % 2) * gap } : { x: 20, y: top + i * gap }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      aria-hidden="true"
      className={`hanko ${className}`}
      focusable="false"
    >
      <defs>
        <filter id={`w${id}`} x="-10%" y="-10%" width="120%" height="120%">
          <feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="2" seed="7" result="n" />
          <feDisplacementMap in="SourceGraphic" in2="n" scale="0.9" result="d" />
          <feTurbulence type="fractalNoise" baseFrequency="0.35" numOctaves="1" seed="3" result="m" />
          <feColorMatrix
            in="m"
            type="matrix"
            values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 -3.2 2.75"
            result="mask"
          />
          <feComposite in="d" in2="mask" operator="in" />
        </filter>
        <mask id={`t${id}`}>
          {shape === 'round' ? (
            <circle cx="20" cy="20" r="18.5" fill="#fff" />
          ) : (
            <rect x="1.5" y="1.5" width="37" height="37" rx="2.5" fill="#fff" />
          )}
          {chars.map((c, i) => (
            <text
              key={`${c}${i}`}
              x={pos(i).x}
              y={pos(i).y}
              textAnchor="middle"
              dominantBaseline="central"
              fontSize={fs}
              fontWeight={800}
              fill="#000"
              style={{ fontFamily: 'var(--font-mincho)' }}
            >
              {c}
            </text>
          ))}
        </mask>
      </defs>
      <g filter={`url(#w${id})`}>
        <rect width="40" height="40" fill="currentColor" mask={`url(#t${id})`} />
      </g>
    </svg>
  )
}
